<template>
    <div>
        <Dialog
            v-model:visible="visible"
            :style="{ width: '600px' }"
            header="Assessment Blocks"
            :modal="true"
            :dismissableMask="true"
            @hide="$emit('hide-dialog', true)"
        >
            <div v-if="assessmentStore.stepBlocks.length">
                <div v-for="block in assessmentStore.stepBlocks" :key="block.id">
                    <div class="card my-3 border-1">
                        <brick
                            v-for="attribute in block.attributes"
                            :field="attribute"
                            :key="attribute.id"
                        />
                    </div>
                </div>
            </div>

            <span v-else>No Steps/Blocks available</span>
        </Dialog>
    </div>
</template>

<script setup>
// Brick is kind of outdated in the modular structure here
// make sure to update it later
import Brick from '@/components/block/brick/Brick.vue';
import { ref, inject } from 'vue';
const visible = ref(true);
const assessmentStore = inject('assessmentStore');
</script>